import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import store from '../store/configureStore';

import * as HeaderActions from '../actions/Header';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as Header from '../constants/Header';
import UserSelectLifeCheck from '../components/Organisms/UserSelectLifeCheck';

type AllState = ReturnType<typeof store.getState>;

const UserSelectLifeCheckContainer: FC = () => {
  const dispatch = useDispatch();
  const moffAPI = useSelector((state: AllState) => state.moffAPI);
  const appUser = useSelector((state: AllState) => state.appUser);

  useEffect(() => {
    (async () => {
      document.title = '生活機能チェック';
      dispatch(HeaderActions.setPage(Header.USER_SELECT_LIFE_CHECK));
      await dispatch(MoffAPIActions.getUsers());
      dispatch(MoffAPIActions.duplicateRepeatSort());
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <UserSelectLifeCheck moffAPI={moffAPI} appUser={appUser} />;
};

export default UserSelectLifeCheckContainer;
